module.exports = __webpack_public_path__ + "static/media/Foundation_popup.e4782afb.png";